const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
  
const GetResidentailServiceAllocation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_SERVICE_ALLOCATION_RESIDENTAIL_LIST':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_SERVICE_ALLOCATION_RESIDENTAIL_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default GetResidentailServiceAllocation;